import React from "react";
import {
  Box,
  Flex,
  Text,
  Progress,
  IconButton,
  Spinner,
  useColorModeValue,
} from "@chakra-ui/react";
import { CloseIcon, DownloadIcon } from "@chakra-ui/icons";
import { useExportStore } from "store/exportStore";
import { downloadExportFile } from "hooks/useExport";

const ExportProgressWindow = ({ exportData, onClose }) => {
  const bg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const { removeExport } = useExportStore();

  const getStatusText = () => {
    switch (exportData.status) {
      case "processing":
        return "処理中...";
      case "completed":
        return "完了";
      case "failed":
        return "エラー";
      default:
        return "待機中";
    }
  };

  const getStatusColor = () => {
    switch (exportData.status) {
      case "processing":
        return "blue";
      case "completed":
        return "green";
      case "failed":
        return "red";
      default:
        return "gray";
    }
  };

  const handleDownload = async () => {
    try {
      await downloadExportFile(exportData.exportId, exportData.filename);
      removeExport(exportData.exportId);
      onClose();
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  const handleClose = () => {
    if (exportData.status === "completed" || exportData.status === "failed") {
      removeExport(exportData.exportId);
    }
    onClose();
  };

  return (
    <Box
      bg={bg}
      border="1px solid"
      borderColor={borderColor}
      borderRadius="md"
      p="12px"
      minW="300px"
      maxW="350px"
      boxShadow="lg"
      mb="10px"
    >
      <Flex justifyContent="space-between" alignItems="center" mb="8px">
        <Text fontSize="14px" fontWeight="bold">
          エクスポート進行状況
        </Text>
        <IconButton
          icon={<CloseIcon />}
          size="xs"
          variant="ghost"
          onClick={handleClose}
          aria-label="閉じる"
        />
      </Flex>

      <Text fontSize="12px" color="gray.600" mb="8px">
        {exportData.employeeIds?.length || 0}名のユーザー
      </Text>

      <Flex alignItems="center" gap="8px" mb="8px">
        {exportData.status === "processing" && (
          <Spinner size="sm" color="blue.500" />
        )}
        <Text fontSize="13px" fontWeight="medium" color={getStatusColor() + ".500"}>
          {getStatusText()}
        </Text>
      </Flex>

      {exportData.status === "processing" && (
        <Progress
          size="sm"
          isIndeterminate
          colorScheme="blue"
          mb="8px"
        />
      )}

      {exportData.status === "completed" && (
        <Flex gap="8px" mt="8px">
          <IconButton
            icon={<DownloadIcon />}
            size="sm"
            colorScheme="green"
            onClick={handleDownload}
            aria-label="ダウンロード"
          />
          <Text fontSize="12px" color="green.500" alignSelf="center">
            ダウンロード可能
          </Text>
        </Flex>
      )}

      {exportData.status === "failed" && (
        <Text fontSize="12px" color="red.500" mt="4px">
          {exportData.error || "エラーが発生しました"}
        </Text>
      )}
    </Box>
  );
};

export default ExportProgressWindow;

